import { inject, type Injector, runInInjectionContext } from '@angular/core';
import {
  AdministrationV1Configuration,
  AdministrationV2Configuration,
  BillingApiConfiguration,
  DatasourceApiConfiguration,
  ErrorDetectionV1Configuration,
  ErrorDetectionV2Configuration,
  FFuFAutomationApiConfiguration,
  FFuFKeycloakUsersApiConfiguration,
  FFuFLogFilesApiConfiguration,
  FFuFQuotaStatisticsApiConfiguration,
  IntervalImportApiConfiguration,
  ReportingApiConfiguration,
  SolarLogAdapterApiConfiguration,
  SolarLogInterchangeApiConfiguration,
  TimelineApiConfiguration,
  VisualisationApiConfiguration,
  WeatherForecastApiConfiguration,
  WidgetApiConfiguration
} from '@sds/api';
import { ApiConfiguration as FilestorageApiConfiguration } from '@sds/apis/filestorage';

import { NotificationService } from '@sds/api/ffuf-notifications/services';
import {
  FFUFUsersApiDeviceService,
  FFUFUsersApiProfitcenterService,
  FFUFUsersApiUserService
} from '@sds/api/ffuf-users/services';
import { ConfigProperty, type ConfigService } from '@sds/shared';

export async function apiServiceRootUrlsInitializer(configService: ConfigService, injector: Injector): Promise<void> {
  runInInjectionContext(injector, () => {
    inject(AdministrationV1Configuration).rootUrl = configService.get(ConfigProperty.AdministrationApi);
    inject(AdministrationV2Configuration).rootUrl = configService.get(ConfigProperty.AdministrationApi);
    inject(BillingApiConfiguration).rootUrl = configService.get(ConfigProperty.BillingApi);
    inject(DatasourceApiConfiguration).rootUrl = configService.get(ConfigProperty.DatasourceApi);
    inject(ErrorDetectionV1Configuration).rootUrl = configService.get(ConfigProperty.ErrorDetectionApi);
    inject(ErrorDetectionV2Configuration).rootUrl = configService.get(ConfigProperty.ErrorDetectionApi);
    inject(ReportingApiConfiguration).rootUrl = configService.get(ConfigProperty.ReportingApi);
    inject(TimelineApiConfiguration).rootUrl = configService.get(ConfigProperty.TimelineApi);
    inject(VisualisationApiConfiguration).rootUrl = configService.get(ConfigProperty.VisualisationApi);
    inject(WidgetApiConfiguration).rootUrl = configService.get(ConfigProperty.WidgetsApi);
    inject(NotificationService).rootUrl = configService.get(ConfigProperty.NotificationsApi);
    inject(FFUFUsersApiUserService).rootUrl = configService.get(ConfigProperty.UserApiUrl);
    inject(FFUFUsersApiDeviceService).rootUrl = configService.get(ConfigProperty.UserApiUrl);
    inject(FFUFUsersApiProfitcenterService).rootUrl = configService.get(ConfigProperty.UserApiUrl);
    inject(FFuFKeycloakUsersApiConfiguration).rootUrl = configService.get(ConfigProperty.PasswordApiUrl);
    inject(WeatherForecastApiConfiguration).rootUrl = configService.get(ConfigProperty.WeatherDataApi);
    inject(SolarLogAdapterApiConfiguration).rootUrl = configService.get(ConfigProperty.SolarLogAdapterApi);
    inject(FFuFLogFilesApiConfiguration).rootUrl = configService.get(ConfigProperty.LogfileApiUrl);
    inject(FFuFQuotaStatisticsApiConfiguration).rootUrl = configService.get(ConfigProperty.QuotaApiUrl);
    inject(FFuFAutomationApiConfiguration).rootUrl = configService.get(ConfigProperty.AutomationApiUrl);
    inject(FFuFAutomationApiConfiguration).logsRootUrl = configService.get(ConfigProperty.AutomationLogsApiUrl);
    inject(IntervalImportApiConfiguration).rootUrl = configService.get(ConfigProperty.IntervalImport);
    inject(FilestorageApiConfiguration).rootUrl = configService.get(ConfigProperty.FilestorageApi);
    inject(SolarLogInterchangeApiConfiguration).rootUrl = configService.get(ConfigProperty.SolarLogInterchangeApi);
  });
}
